import React from "react";
import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import {Tag} from "components/Tag";
import {color} from "constants/color.consts";

const NewTag = ({date}) => {
  const showNewTag = (until) => {
    const endDate = new Date(until);
    if (/^\d{4}-\d{2}-\d{2}$/.test(until)) {
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0);
    }
    return new Date() < endDate;
  };
  const getDateClass = (date) =>
    /^\d{4}-\d{2}-\d{2}$/.test(date) ? ` expires-${date}` : "";

  return showNewTag(date) ? (
    <Tag
      text="MAIN_MENU_BADGE_NEW"
      needTranslation
      color={color.red}
      uppercase
      tiny
      noBackground
      addClass={`ml-2${getDateClass(date)}`}
    />
  ) : null;
};

export const SubscriptionTabs = ({tabs, active, setActive}) => {
  const {t} = useTranslation();

  const descriptionClass = (active, current) =>
    `fz-12 __normal ${active === current ? "discrete-text" : "mid-gray"}`;

  return (
    <Tabs
      activeKey={active}
      onChange={setActive}
      centered
      items={tabs.map((item) => ({
        label: (
          <React.Fragment>
            <div className="df-row-jcc-center">
              {t(item.title)}
              <NewTag date={item.isNewAt} />
            </div>
            <div className={descriptionClass(active, item.id)}>{t(item.description)}</div>
          </React.Fragment>
        ),
        key: item.id,
        disabled: item.disabled,
      }))}
      className="subscriptions__tabs"
    />
  );
};
